module.exports = __webpack_public_path__ + "static/media/everyday_digital.0516c439.png";